import "./Products.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
} from "antd";
import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { DeleteOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import {
  PageSetting,
  ProductRaw,
  ProductsMessages,
  Query,
  SortMode,
} from "../../..";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/products/get-products-actions";
import NewProductModal from "../../../components/Forms/Modal/Products/NewProduct";
import UpdateProductModal from "../../../components/Forms/Modal/Products/UpdateProduct";
import { findById } from "../../../../controllers/store/actions/products/update-product-actions";
import { Modal } from "antd";
import { remove } from "../../../../controllers/store/actions/products/delete-product-action";
import { clear } from "../../../../controllers/store/actions/products/create-product-action";

const { confirm } = Modal;
const { Header, Content } = Layout;
const dispatch = store.dispatch;

const query: Query = { filter: {} };
const Products: React.FC = () => {
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [api, contextHolder] = notification.useNotification();
  const productsState = useSelector((state: any) => state.products);
  const updatedProductState = useSelector((state: any) => state.updatedProduct);
  const deletedProductState = useSelector((state: any) => state.deletedProduct);
  const createdProductState = useSelector((state: any) => state.createdProduct);
  const userState = useSelector((state: any) => state.user.user);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const columns: TableProps<ProductRaw>["columns"] = [
    {
      title: "Producto",
      dataIndex: "name",
      key: "name",
      render: (text) => text,
    },
    {
      title: "Tipo",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Grupo",
      dataIndex: "group",
      key: "group",
    },
    {
      title: "Institución",
      dataIndex: "university",
      key: "university",
    },
    {
      title: "Fecha de creación",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Fecha de modificación",
      dataIndex: "updated_at",
      key: "updated_at",
    },
    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 250,
      render: (_, record: ProductRaw) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              if (record.id) {
                dispatch(findById(record.id));
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            type="default"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: ProductsMessages.Title,
                content: ProductsMessages.ProductsConfirmDeleteMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(find(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const showCreatedProductMessageSuccess = () => {
    api["success"]({
      key: 1,
      message: ProductsMessages.Title,
      description: ProductsMessages.ProductCreated,
    });
    dispatch(clear());
    return null;
  };

  const showDeletedProductMessage = () => {
    api["success"]({
      key: 1,
      message: ProductsMessages.Title,
      description: ProductsMessages.ProductsDeleteSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  const showUpdatedProductMessage = () => {
    api["success"]({
      key: 1,
      message: ProductsMessages.Title,
      description: ProductsMessages.ProductsUpdateSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  useEffect(() => {
    dispatch(find(1, pageSize, { filter: {} }));
    setInitialDataLoaded(true);
  }, [pageSize]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    if (value) {
      query.search = value;
      query.meta = "filter_count";
    } else {
      delete query.search;
    }
    dispatch(find(1, pageSize, query));
  };

  return (
    <Layout className="products-layout">
      {contextHolder}
      {createdProductState.createdProduct
        ? showCreatedProductMessageSuccess()
        : null}
      {deletedProductState.removed ? showDeletedProductMessage() : null}
      {updatedProductState.updatedProduct ? showUpdatedProductMessage() : null}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="product-content">
        <Card className="products-card">
          <NewProductModal
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(find(1, pageSize, query));
            }}
            onCancel={() => {
              setVisibleCreateModal(false);
            }}
          />
          <UpdateProductModal
            product={updatedProductState.product}
            visible={visibleUpdateModal}
            onUpdated={() => {
              setVisibleUpdateModal(false);
              dispatch(find(1, pageSize, query));
            }}
            onCancel={() => {
              setVisibleUpdateModal(false);
            }}
          />

          {!initialDataLoaded && productsState?.list?.length === 0 ? (
            <>
              <br />
              <br />
              <br />
              <br />
              <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                imageStyle={{ height: 60 }}
                description={<span>No tienes productos aún</span>}
              >
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setVisibleCreateModal(!visibleCreateModal);
                  }}
                  type="primary"
                >
                  Agregar Producto
                </Button>
              </Empty>
              <br />
              <br />
              <br />
              <br />
            </>
          ) : (
            <>
              <h1 className="heading-content-title">Productos</h1>
              <br />
              <Row gutter={[8, 8]} style={{ width: "100%", marginBottom: 20 }}>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-start"}>
                    <Search
                      placeholder="Buscar"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onSearch={handleSearch}
                      enterButton
                    />
                  </Flex>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-end"}>
                    <Button
                      type="primary"
                      onClick={() => setVisibleCreateModal(!visibleCreateModal)}
                      size="middle"
                      icon={<PlusOutlined />}
                    >
                      Agregar producto
                    </Button>
                  </Flex>
                </Col>
              </Row>
              <Skeleton
                loading={productsState.isLoading}
                active
                className="full-width"
              >
                <Table
                  scroll={{ x: 1500 }}
                  sticky={{ offsetHeader: 0 }}
                  pagination={{
                    locale: {
                      jump_to: "Ir a",
                      items_per_page: "Items por pagina",
                    },
                    total:
                      productsState.meta?.total_count ||
                      productsState.meta?.filter_count,
                    current: page,
                    pageSize: PageSetting.limit,
                    onChange: (page) => {
                      dispatch(find(page, pageSize, query));
                      setPage(page);
                    },
                    onShowSizeChange: (pageSize) => {
                      dispatch(find(page, pageSize, query));
                      setPageSize(pageSize);
                    },
                  }}
                  locale={{ emptyText: "Sin Resultados." }}
                  columns={columns}
                  dataSource={productsState.list}
                />
              </Skeleton>
            </>
          )}
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Products;
